import { createAction } from 'redux-actions';
import { API_NEW_TERM_SCHOOL_CLASS_SETTING } from 'constants/endpoints';
import { StatusEnum } from 'flex/actions/http/StatusEnum';

/**
 * Prefix 付きの ActionType を作成する
 */
const createActionType = <ActionType extends string>(actionType: ActionType) => {
    const prefix = 'CONNECTION/NEW_TERM_SCHOOL_CLASS_SETTING';
    return `${prefix}/${actionType}` as `${typeof prefix}/${ActionType}`;
};

export const view = createAction(
    createActionType('VIEW' as const),
    () => {
        return {
            method: 'get',
            api: `${API_NEW_TERM_SCHOOL_CLASS_SETTING}/view`,
        };
    },
    () => ({ fetch: true, status: StatusEnum.REQUEST })
);

export const save = createAction(
    createActionType('SAVE' as const),
    (data) => {
        return {
            method: 'post',
            data,
            api: `${API_NEW_TERM_SCHOOL_CLASS_SETTING}/save`,
        };
    },
    () => ({ fetch: true, status: StatusEnum.REQUEST })
);
